import { request } from '../../../utils/request';

type WalletCreationResponse = {
  success: boolean;
  wallet_id: string;
  message: string;
};
export default function (props: {
  customer_id: number;
  currency_id?: string;
  authToken: string;
}): Promise<WalletCreationResponse> {
  return request({
    url: '/sterling/kyc/wallet',
    method: 'POST',
    formData: {
      customer_id: props?.customer_id,
      currency_id: props?.currency_id,
    },
    headers: {
      Authorization: `Bearer ${props.authToken}`,
    },
    onError: (error) => {
      throw error;
    },
  });
}
